import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { AuthApiService } from '@angular-workspace/services';

@Component({
  selector: 'app-provider-data-provider-entity',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
  ],
  templateUrl: './data-provider-entity.component.html',
  styleUrl: './data-provider-entity.component.scss',
})
export class ProviderDataProviderEntityComponent implements OnInit {
  dataProviderEntityForm!: FormGroup;
  
  constructor(
    private fb: FormBuilder,
    private authApiService: AuthApiService
  ) {}
  
  async ngOnInit(): Promise<void> {
    this.initForm();
    await this.loadDataProviderEntityData();
  }
  
  initForm(): void {
    // All fields are disabled since user is already approved
    this.dataProviderEntityForm = this.fb.group({
      entityName: [{ value: '', disabled: true }],
      registeredEmail: [{ value: '', disabled: true }],
      userName: [{ value: '', disabled: true }],
      jobTitle: [{ value: '', disabled: true }],
      employeeId: [{ value: '', disabled: true }]
    });
  }
  
  async loadDataProviderEntityData(): Promise<void> {
    try {
      const userData = await this.authApiService.getUserInfo();
      
      if (userData && userData['result']) {
        const result = userData['result'];
        const organisation = result['organisation'] || result['organization'] || {};
        
        // Get organisationId from user API
        let organisationId: string | null = null;
        if (organisation['organisationId']) {
          organisationId = organisation['organisationId'];
        }
        
        // Get organisation name by matching organisationId with getAllOrganisations API
        let organisationName = '';
        if (organisationId) {
          try {
            const organisationsResponse = await this.authApiService.getAllOrganisations(1, 100);
            
            // Extract organisations list from response
            let organisations: any[] = [];
            if (Array.isArray(organisationsResponse)) {
              organisations = organisationsResponse;
            } else if (organisationsResponse && organisationsResponse['result']) {
              organisations = Array.isArray(organisationsResponse['result']) 
                ? organisationsResponse['result'] 
                : organisationsResponse['result']['organisations'] || [];
            }
            
            // Match organisationId with list and get the name
            const matchedOrganisation = organisations.find((org: any) => {
              const orgId = org.id || org.organisationId || org.organisation_id;
              return orgId === organisationId;
            });
            
            if (matchedOrganisation) {
              // Prioritize orgName as it's the field name in the API response
              organisationName = matchedOrganisation.orgName || 
                               matchedOrganisation.organisationName || 
                               matchedOrganisation.organizationName || 
                               matchedOrganisation.name || '';
            }
          } catch (orgError) {
            console.error('Error fetching organisations:', orgError);
            // Fallback to organisation name from user data if API call fails
            organisationName = organisation['organisationName'] || 
                             organisation['organizationName'] || 
                             organisation['orgName'] || 
                             organisation['name'] || '';
          }
        } else {
          // Fallback to organisation name from user data if no organisationId
          organisationName = organisation['organisationName'] || 
                           organisation['organizationName'] || 
                           organisation['orgName'] || 
                           organisation['name'] || '';
        }
        
        // Temporarily enable form controls to patch values
        Object.keys(this.dataProviderEntityForm.controls).forEach(key => {
          this.dataProviderEntityForm.get(key)?.enable();
        });
        
        // Map user data to form fields
        const formData: any = {
          userName: result['name'] || 
                     result['preferredUsername'] || 
                     result['preferred_username'] || 
                     (result['givenName'] && result['familyName'] ? `${result['givenName']} ${result['familyName']}` : '') ||
                     result['email'] || '',
          registeredEmail: result['email'] || '',
          entityName: organisationName,
          jobTitle: result['jobTitle'] || 
                   organisation['jobTitle'] || 
                   result['job_title'] || 
                   organisation['job_title'] || '',
          employeeId: result['empId'] || 
                     result['employeeId'] || 
                     result['employee_id'] || 
                     organisation['empId'] || 
                     organisation['employeeId'] || 
                     organisation['employee_id'] || ''
        };
        
        // Patch form with data
        this.dataProviderEntityForm.patchValue(formData);
        
        // Re-disable form controls
        Object.keys(this.dataProviderEntityForm.controls).forEach(key => {
          this.dataProviderEntityForm.get(key)?.disable();
        });
      }
    } catch (error) {
      console.error('Error loading organisation data:', error);
    }
  }
}



